
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Adv05ItemDetailsGrid extends Serenity.EntityGrid<Adv05ItemDetailsRow, any> {
        protected getColumnsKey() { return Adv05ItemDetailsColumns.columnsKey; }
        protected getDialogType() { return Adv05ItemDetailsDialog; }
        protected getIdProperty() { return Adv05ItemDetailsRow.idProperty; }
        protected getInsertPermission() { return Adv05ItemDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return Adv05ItemDetailsRow.localTextPrefix; }
        protected getService() { return Adv05ItemDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}